// shell/components/entity-fields/view-renderers/boolean-renderer.ts

import { createElement } from '../../../utils/dom';
import type { BooleanViewField } from '../../entity-view/types';

/**
 * Renders a boolean field value with customizable labels.
 */
export function renderBooleanView<T>(
    field: BooleanViewField<T>,
    value: unknown,
    _model: T
): HTMLElement {
    const container = createElement('div', {
        className: 'ev-field-view ev-field-view--boolean',
    });

    if (value === null || value === undefined) {
        container.classList.add('ev-field-view--empty');
        container.textContent = '—';
        return container;
    }

    const boolValue = Boolean(value);
    const trueLabel = field.trueLabel ?? 'Yes';
    const falseLabel = field.falseLabel ?? 'No';

    container.textContent = boolValue ? trueLabel : falseLabel;
    container.classList.add(boolValue ? 'ev-field-view--true' : 'ev-field-view--false');

    return container;
}
